import { render, staticRenderFns } from "./MediaSetting.vue?vue&type=template&id=0a9656a6&scoped=true&"
import script from "./MediaSetting.vue?vue&type=script&lang=js&"
export * from "./MediaSetting.vue?vue&type=script&lang=js&"
import style0 from "./MediaSetting.vue?vue&type=style&index=0&id=0a9656a6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9656a6",
  null
  
)

export default component.exports